import { pageInfoFragment } from "@saleor/fragments/pageInfo";
import makeBossQuery from "@saleor/hooks/makeBossQuery";
import gql from "graphql-tag";

import { PaymentEvents, PaymentEventsVariables } from "./types/PaymentEvents";

export const PaymentEventsQuery = gql`
  ${pageInfoFragment}
  query PaymentEvents(
    $before: String
    $after: String
    $first: Int
    $last: Int
    $filter: PaymentEventsFilterInput!
  ) {
    paymentEvents(
      before: $before
      after: $after
      first: $first
      last: $last
      filter: $filter
    ) {
      pageInfo {
        ...PageInfoFragment
      }
      edges {
        node {
          id
          order_code
          transaction_id
          acquirement_id
          event_type
          amount
          parameters
          smop_trans_id
          customer_name
          created_at
        }
      }
    }
  }
`;

export const usePaymentEventsQuery = makeBossQuery<
  PaymentEvents,
  PaymentEventsVariables
>(PaymentEventsQuery);
